import { render, staticRenderFns } from "./NewCommentBox.vue?vue&type=template&id=431f9db6&scoped=true&"
import script from "./NewCommentBox.vue?vue&type=script&lang=js&"
export * from "./NewCommentBox.vue?vue&type=script&lang=js&"
import style0 from "./NewCommentBox.vue?vue&type=style&index=0&id=431f9db6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431f9db6",
  null
  
)

export default component.exports